import { render, staticRenderFns } from "./SingleDestination.vue?vue&type=template&id=f4d62bee&scoped=true&"
import script from "./SingleDestination.vue?vue&type=script&lang=js&"
export * from "./SingleDestination.vue?vue&type=script&lang=js&"
import style0 from "./SingleDestination.vue?vue&type=style&index=0&id=f4d62bee&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d62bee",
  null
  
)

export default component.exports